import React from "react";
import MainLayout from "./MainLayout";
import OnBoardingComplete from "../common/OnBoarding/OnBoardingComplete";

const Skills = (props) => <MainLayout component={OnBoardingComplete} />;

export default Skills;
